// extracted by mini-css-extract-plugin
module.exports = {"fullbleed":"image_fullbleed__Us7oo","custom-img":"image_custom-img__qJd7y","unsetimg":"image_unsetimg__jRMVd"};